/**
 * [搜索]
 */

function statistics(adskey) {
    window._jc_ping = window._jc_ping || [];
    _jc_ping.push([
        '_trackBlockClick',
        adskey
    ]);
}

function getIndex(parents, a) {
    var index = '';
    parents.find('a').each(function(i) {
        if (this == a) {
            index = i;
            return false;
        }
    });
    return index;
}

$.each([
    ['#header', 'eyARze'],
    ['#mainList', 'AJZvYv'],
    ['.side .focus-in', 'NBzQje'], //焦点图
    ['.rec-reading', 'fyeYri'], //推荐阅读
    ['.hao-welfare', 'byANBj'], //发号福利
    ['.game-test', 'yUJvMn'],
    ['.bi-waiting-list', '6jmMfq'],
    ['.bi-game-list', 'vEFVN3']
], function(i, item) {
    $(item[0]).attr('data-bi', item[1]);
});

$('body').on('mousedown', '[data-bi] a', function() {
    var a = $(this);
    var parents = a.parents('[data-bi]');
    var adskey = parents.data('bi');
    var index = getIndex(parents, a[0]);
    if (adskey) {
        statistics(adskey + '|' + index);
    }
});

$('.search-form').on('submit', function() {
    statistics('eyARze|15');
});


//////////////////
// WEBPACK FOOTER
// ./src/component/bi.js
// module id = 2
// module chunks = 0